<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: unknown
    hover?: boolean
  }>(),
  {
    modelValue: undefined,
    hover: false
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: unknown): void
}>()

const parent = ref<HTMLElement | null>(null)

const state = reactive<{
  open: boolean
  internalValue: unknown
}>({
  open: false,
  internalValue: props.modelValue
})

const setValue = (value: unknown) => {
  state.internalValue = value

  emit('update:modelValue', value)
}

const close = () => {
  state.open = false
}

const toggle = (value: boolean) => {
  state.open = value
}

useClickOutside(parent, () => {
  if (props.hover) return

  close()
})

const mouseenter = () => {
  if (props.hover) state.open = true
}

const mouseleave = () => {
  if (props.hover) state.open = false
}
</script>

<template>
  <span ref="parent" class="tw-relative" @mouseenter="mouseenter" @mouseleave="mouseleave">
    <Toggle class="tw-w-full" :open="state.open" @toggle="toggle">
      <template #header>
        <slot :value="state.internalValue" name="header">{{ state.internalValue }}</slot>
      </template>

      <template #content>
        <!-- `dropdown-content` is a styling hook used by parents via :deep() -->
        <div class="dropdown-content tw-relative">
          <slot name="content" :set-value="setValue" :close="close" />
        </div>
      </template>
    </Toggle>
  </span>
</template>
